<template>
  <div class="section">
    <h4 class="text-muted">{{section.label}}</h4>

    <device-settings-body-section-field v-for="(fieldSection, index) in section.fields"
                                        :field="fieldSection"
                                        :sectionValue="value"
                                        :section="section"
                                        :key="index"
                                        @changeValue="changeValue" />

  </div>
</template>

<script>
import DeviceSettingsBodySectionField from "@views/admin/devices/components/device-modal/components/sections/DeviceSettingsBodySectionField.vue";

export default {
  components: {
    DeviceSettingsBodySectionField,
  },

  props: {
    section: {
      type: Object,
    },
    values: {
      type: Object,
    },
  },

  data() {
    return {};
  },

  computed: {
    value() {
      return this.values[this.section.name];
    },
  },

  methods: {
    changeValue(val, model, sectionName) {
      this.$emit("changeValue", val, model, sectionName);
    },
  },
};
</script>

<style lang="scss" scoped>
h4 {
  text-align: center;
}
.section {
  margin-top: 10px;
}

.flex {
  align-items: center;
  justify-content: space-between;
}

.ips-firewall {
  width: 100%;
  text-align: center;
}
</style>
